import { MagicLinkRequestScheme } from "@digits-graphql/frontend/graphql-public"

export interface MagicLinkScheme {
  scheme?: MagicLinkRequestScheme
  state?: string
}

export async function getMagicLinkScheme(): Promise<MagicLinkScheme> {
  if (window.digitsMagicLinkScheme === undefined || window.digitsMagicLinkState === undefined) {
    return {}
  }
  const schemeString = await window.digitsMagicLinkScheme()
  const state = await window.digitsMagicLinkState()
  const scheme =
    MagicLinkRequestScheme[schemeString as MagicLinkRequestScheme] ?? MagicLinkRequestScheme.Https

  return {
    scheme,
    state,
  }
}
